import React from "react";

const PayNowButton = () => {
  const handlePayment = async () => {
    const res = await fetch("https://backend.kalpcargo.com/api/payment", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        amount: "100", // INR
        productinfo: "Sample Product",
        firstname: "John",
        email: "john@example.com",
        phone: "9999999999",
      }),
    });

    const data = await res.json();
    console.log("data pay u  ==", data);

    // Create form
    const form = document.createElement("form");
    form.method = "POST";
    form.action = data.action;

    for (const key in data) {
      if (key !== "action") {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = data[key];
        form.appendChild(input);
      }
    }

    document.body.appendChild(form);
    form.submit();
  };

  return <button onClick={handlePayment}>Continue Payment</button>;
};

export default PayNowButton;

// import React from "react";

// const PayNowButton = () => {
//   const handlePayment = async () => {
//     const res = await fetch("https://backend.kalpcargo.com/api/payment", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         amount: "100",
//         productinfo: "Sample Product",
//         firstname: "John",
//         email: "john@example.com",
//         phone: "9999999999"
//       }),
//     });

//     const html = await res.text(); // get raw HTML

//     // Inject HTML form and submit
//     const div = document.createElement("div");
//     div.innerHTML = html;
//     document.body.appendChild(div);
//     const form = div.querySelector("form");
//     if (form) {
//       form.submit();
//     } else {
//       alert("Payment form generation failed.");
//     }
//   };

//   return (
//     <button onClick={handlePayment}>
//       Continue Payment
//     </button>
//   );
// };

// export default PayNowButton;
